<template>
  <div id="app">
    <Header class="header_container"></Header>
    <!-- <el-scrollbar> -->
    <!-- :style="{ minHeight: minHeight + 'px' }" -->
    <!-- ref="main" -->
    <main ref="mainRef" class="main_container main">
      <router-view />
    </main>
    <!-- <Footer v-if="reverseFooter" class="footer_container main"></Footer> -->
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
import Header from '@/views/layout/Header'
// import Footer from '@/views/layout/Footer'
// import { parseInterval } from '@/components/tradingview/js/utils'
import themeColor from '@/common/js/themeColor'
import { mapState, mapGetters } from 'vuex'
import { createSocket, sendWSPush } from '@/utils/webSocket'
export default {
  name: 'app',
  data() {
    return {
      input: '',
      minHeight: 0, // 设置 主要容器 最小高度的值
      // reverseFooter: false // 显示隐藏尾部组件（默认： 显示）
    }
  },
  components: {
    Header,
    // Footer
  },
  computed: {
    ...mapState({
      currentSkin: (store) => store.transaction.currentSkin,
    }),
    ...mapGetters(['parameterizedTradingPair', 'interval']),
  },
  watch: {
    // parameterizedTradingPair(newVal, oldVal) {
    //   sendWSPush({
    //     channel: 'kline',
    //     market: oldVal,
    //     type,
    //     subType: 'unsub'
    //   })
    //   sendWSPush({
    //     channel: 'req_kline',
    //     market: newVal,
    //     type,
    //     from,
    //     to
    //   })
    //   sendWSPush({
    //     channel: 'kline',
    //     market: newVal,
    //     type,
    //     subType: 'sub'
    //   })
    // },
    // interval(newVal) {
    //   this.loading = true
    //   const { type, from, to } = parseInterval(newVal)
    //   sendWSPush({
    //     channel: 'req_kline',
    //     market: this.parameterizedTradingPair,
    //     type,
    //     from,
    //     to
    //   })
    //   sendWSPush({
    //     channel: 'kline',
    //     market: this.parameterizedTradingPair,
    //     type,
    //     subType: 'sub'
    //   })
    // }
    $route: {
      handler(to, from) {
        const { mainRef } = this.$refs
        if (mainRef) {
          mainRef.scrollTo({
            behavior: 'smooth',
            top: 0,
          })
        }

        // const routeName = to.name
        // switch (routeName) {
        //   case 'signin':
        //     this.reverseFooter = false
        //     break
        //   case 'register':
        //     this.reverseFooter = false
        //     break
        //   case 'forgetPassword':
        //     this.reverseFooter = false
        //     break
        //   default:
        //     this.reverseFooter = true
        // }
      },
      immediate: true,
    },
  },
  created() {
    createSocket(process.env.VUE_APP_TRADING_PAIR_WS)
    sendWSPush({ channel: 'public', language: 'zh' })
    // const { type, from, to } = parseInterval(this.interval)
    /* eslint-disalbe */
    // sendWSPush({ channel: 'public', language: 'zh' })
    // sendWSPush({ channel: this.parameterizedTradingPair, language: 'zh' })
    // sendWSPush({
    //   channel: 'req_kline',
    //   market: this.parameterizedTradingPair,
    //   type,
    //   from,
    //   to
    // })
    // sendWSPush({
    //   channel: 'kline',
    //   market: this.parameterizedTradingPair,
    //   type,
    //   subType: 'sub'
    // })
    /* eslint-enable */
  },
  mounted() {
    // const innHeight = window.innerHeight
    // this.minHeight = innHeight

    // 设置当前主题样式
    const obj = themeColor[this.currentSkin]
    for (let key in obj) {
      document
        .getElementsByTagName('body')[0]
        .style.setProperty(`--${key}`, obj[key])
    }
  },
}
</script>
<style lang="less" scoped>
#app {
  position: relative;
  .header_container {
    position: fixed;
    top: 0;
    width: 100%;
    background: #0a0a0c;
    z-index: 1000;
  }
  .main_container {
    width: 100%;
    height: calc(100vh - 60px);
    margin-top: 60px;
    overflow: auto;
    // background: #000;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(144, 147, 153, 0.3);
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(144, 147, 153, 0.5);
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }
  // .el-scrollbar {
  //   height: calc(100vh - 60px);
  //   margin-top: 60px;
  //   .footer_container {
  //     background: rgba(8, 17, 38, 1);
  //   }

  // ::v-deep .el-scrollbar__wrap {
  //   overflow-x: auto;
  //   margin-bottom: 0;
  // }
  // ::v-deep .el-scrollbar__bar.is-horizontal {
  //   display: none;
  // }
  // }
}
</style>
